import React from 'react';
import { Tab as MuiTab } from '@mui/material';

const Tab = ({ label, value, ...rest }) => (
  <MuiTab label={label} value={value} {...rest} />
);
export default Tab;
